import {PlugTypeDto} from './plugType';

export interface AggregatedPlug {
    built?: number;
    chargeMode?: string;
    count?: number;
    electricyKind?: string;
    error?: number;
    free?: number;
    iconRef?: string;
    iconUrl?: string;
    maxCurrent?: number;
    maxPower?: number;
    orientation?: string;
    outletModel?: string;
    plugElectricyKind?: string;
    plugExternalRefsByChargePointRef?: { [index: string]: string[] };
    plugRefsByChargePointRef?: { [index: string]: string[] };
    servicing?: number;
    unknown?: number;
    voltage?: number;
}

export enum PlugOrientation {
    SOCKET_WITH_CABLE = 'SOCKET_WITH_CABLE',
    SOCKET_WITHOUT_CABLE = 'SOCKET_WITHOUT_CABLE'
}

export interface PlugResultDto extends AggregatedPlug {
    chargePointRef?: string;
    chargePointVisualId?: string;
    lastUsageDate?: string;
    plugTypeIconRef?: string;
    plugTypeIconUrl?: string;
    plugTypeLabel?: string;
}

export interface PlugDto {
    id?: string;
    plugType?: string;
    plugTypeDto?: PlugTypeDto;
    Orientation?: string;
}

export interface Plug {
    _id: string;
}
